import { Injectable } from '@angular/core';
import{BehaviorSubject} from 'rxjs'
import { mergeMapTo } from 'rxjs/operators';
var CryptoJS = require("crypto-js");
import config from '../../assets/config.json';

@Injectable({
  providedIn: 'root'
})
export class MemoryStorageService {
private memory:Record<string,any>={};
public configvalue = config.inputvalue;
setItem(key:string,value:any):void{
  var keyname = this.hash(key);
    if (value != undefined && value != null) {
      var setvalue = this.encrypt(value.toString());   
      this.memory[keyname]= setvalue;  
    }
  
}
getItem<T>(key:string){
  var keyname = this.hash(key);
    var getdata = this.memory.hasOwnProperty(keyname)?this.memory[keyname]:null;
    if (getdata != undefined && getdata != null) {
      return this.decrypt(getdata);
    }
}
getAll(): Record<string, any> {  
  return { ... this.memory };
}  
removeItem(key: string): void {
  delete this.memory[key];
} 
clear(): void {
  this.memory = {};  
}
public hash(key: any): any {
  key = CryptoJS.SHA256(key, this.configvalue.toString()+"90");
  return key.toString();
}
public encrypt(data: any) {
  data = CryptoJS.AES.encrypt(data,  this.configvalue.toString()+"90");
  data = data.toString();
  return data;
}
public decrypt(data: any) {
  data = CryptoJS.AES.decrypt(data,  this.configvalue.toString()+"90");
  data = data.toString(CryptoJS.enc.Utf8);
  return data;
}
public setuserdatainmemory(key: string, value: any){
  var keyname = this.hash(key);
  this.memory[keyname]= value;
}
public getuserdatainmemory(key: string){
  var keyname = this.hash(key);
  var getdata = this.memory.hasOwnProperty(keyname)?this.memory[keyname]:null;
  return getdata;
}
}
